<template>
  <div class="min-height-for-section mb_controller w-100 pt-livetv bg-blur">
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="col-12">
          <div class="w-100">
            <h1>Dasar Keselamatan</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row mt-4 mx-1 mx-md-3">
        <div class="col-12 text-left my-2 px-0 px-md-4">
          <ol class="pl-3">
            <li class="list mb-4">
              Sumbangan dan penyebaran maklumat yang dilarang dan bahan-bahan
              negatif yang bertentangan dengan dasar-dasar negara adalah
              dilarang.
            </li>
            <li class="list mb-4">
              Menyebar maklumat berbau politik, hasutan atau perkauman atau
              apa-apa yang menjejaskan reputasi Jabatan Penyiaran Malaysia
              adalah dilarang.
            </li>
            <li class="list mb-4">
              Pengunjung yang ingin menggunakan kemudahan seperti forum
              dikehendaki mendaftar sebagai langkah keselamatan bagi mengelakkan
              perkara-perkara yang tidak diingini timbul.
            </li>
            <li class="list mb-4">
              Pengunjung hendaklah memastikan fail yang dihantar melalui kepilan
              (attachment) bebas dari virus.
            </li>
            <li class="list mb-4">
              Pengunjung adalah bertanggungjawab sepenuhnya ke atas maklumat
              yang dikunci masuk.
            </li>
            <li class="list mb-4">
              Semua maklumat yang hendak dimuatkan ke dalam Portal RTM mestilah
              mendapat kelulusan Ketua Bahagian/Jabatan.
            </li>
            <li class="list mb-4">
              Laman web agensi atau syarikat yang memerlukan pautan ke Portal
              RTM atau sebaliknya mestilah mendapat kebenaran Ketua Jabatan.
            </li>
            <li class="list mb-4">
              Pencerobohan atau percubaan untuk menggodam Portal RTM adalah
              dilarang.
            </li>
          </ol>
          <p class="ml-3">Terakhir dikemaskini: 12 Januari 2017</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {};
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 90px 0 0;
  min-height: 80vh;
}

h1 {
  font-family: Sf-ui-medium;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  color: #dae12f;
}
p,
.list {
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #fff;
}
</style>
